require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-astrada-bs-react-fela.json") })
        }
      }, "path---package-astrada-bs-react-fela");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-astrada-bs-react-fela!./.cache/json/package-astrada-bs-react-fela.json
// module id = 745
// module chunks = 231608221292675